var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"loading-container",style:({fontSize: `${_vm.getSize}em`})},[_c('loading-spinner')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }